export default {
  dailyCheckTourEvent: {
    tableColumns: {
      procedureName: 'Nume procedura',
      status: 'Stare',
      alerts: 'Alerte',
    },
  },
};
